import styled from '@emotion/styled';

import { FONT, SPACING } from '../../styles/emotion';

export const StarRatings = styled.div`
  display: flex;
`;
export const RatingsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.XXS};
`;

export const Stars = styled.div`
  display: flex;
  align-items: center;
`;

export const ReviewCount = styled.span`
  font-weight: ${FONT.WEIGHT.SEMI_BOLD};
`;

export default { StarRatings, RatingsWrapper, Stars, ReviewCount };
